import React from 'react'

const DarkbackIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M5.9 15H10.1C13.6 15 15 13.6 15 10.1V5.9C15 2.4 13.6 1 10.1 1H5.9C2.4 1 1 2.4 1 5.9V10.1C1 13.6 2.4 15 5.9 15Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.90071 10.3651H9.3447C10.5347 10.3651 11.5007 9.39912 11.5007 8.20912C11.5007 7.01912 10.5347 6.05313 9.3447 6.05313H4.60571" stroke="#111AE9" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.599 7.13885L4.5 6.03287L5.599 4.93387" stroke="#111AE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default DarkbackIcon